import ModalFooter from './modalFooter-TEMPLATE_VERSION'

export default ModalFooter
